<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
            </router-link>
            <div class="flex items-center gap-2">
              <span class="text-2xl">💕</span>
              <span class="font-semibold text-psychology-primary">霍兰德职业兴趣测试</span>
            </div>
          </div>
          <button @click="goBack" class="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
          </button>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-4xl mx-auto space-y-6">
        <!-- 页面标题 -->
        <div class="text-center">
          <h1 class="text-3xl font-bold text-psychology-primary mb-2">霍兰德职业兴趣测试</h1>
          <p class="text-gray-600 text-lg">探索你的职业兴趣，了解你的Holland Code</p>
        </div>

        <!-- 未完成会话检测 -->
        <IncompleteSessionDialog
          v-if="showIncompleteDialog"
          :show="showIncompleteDialog"
          :progress-info="incompleteSessionInfo"
          @continue="handleContinueSession"
          @restart="handleRestartSession"
          @cancel="handleCancelDialog"
        />

        <!-- 开始测试卡片 -->
        <div v-if="!showIncompleteDialog" class="card p-8">
          <div class="space-y-6">
            <!-- 测试介绍 -->
            <div class="text-center">
              <div class="text-6xl mb-4">🎯💼🔬🎨👥📊</div>
              <h2 class="text-2xl font-bold text-gray-800 mb-3">欢迎参加霍兰德职业兴趣测试</h2>
              <p class="text-gray-600 leading-relaxed">
                通过90道科学问题，我们将从六个维度分析你的职业兴趣，
                精准计算你的Holland Code，揭示你的职业兴趣类型和适合的专业方向。
              </p>
            </div>

            <!-- 测试说明 -->
            <div class="bg-psychology-primary-10 rounded-lg p-6">
              <h3 class="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <span>📋</span>
                测试说明
              </h3>
              <ul class="space-y-2 text-gray-700">
                <li class="flex items-start gap-2">
                  <span class="text-psychology-primary mt-1">•</span>
                  <span>共90道选择题，预计需要10-15分钟</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-psychology-primary mt-1">•</span>
                  <span>请根据真实感受选择（喜欢/不喜欢），无需过度思考</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-psychology-primary mt-1">•</span>
                  <span>答题过程会自动保存，可随时继续</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-psychology-primary mt-1">•</span>
                  <span>完成后将获得详细的Holland Code分析报告和专业推荐</span>
                </li>
              </ul>
            </div>

            <!-- 免责声明 -->
            <div class="bg-psychology-info-10 border-2 border-psychology-info-20 rounded-lg p-6">
              <h3 class="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <span>⚠️</span>
                免责声明
              </h3>
              <div class="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>
                  <strong>1. 测试性质：</strong>本测试为趣味性格测试工具，旨在通过有趣的方式帮助您了解自己的性格特征。测试结果仅供娱乐和自我认知参考，不应作为任何专业心理评估、医疗诊断或职业建议的依据。
                </p>
                <p>
                  <strong>2. 结果解释：</strong>测试结果基于算法匹配生成，可能无法完全准确反映您的真实性格。每个人都是独特的，性格是多维度和动态变化的，不应被简单归类。
                </p>
                <p>
                  <strong>3. 隐私保护：</strong>您的所有答题数据和测试结果仅存储在您的本地浏览器中，我们不会收集、存储或向任何第三方分享您的个人信息和测试数据。清除浏览器缓存将删除所有本地数据。
                </p>
                <p>
                  <strong>4. 使用责任：</strong>使用本测试即表示您理解并同意：
                </p>
                <ul class="list-disc list-inside ml-4 space-y-1">
                  <li>本测试不构成任何专业建议</li>
                  <li>测试结果不应用于任何重要决策</li>
                  <li>如有心理健康需求，请咨询专业心理咨询师或医生</li>
                  <li>您自愿参与测试并自行承担使用结果的责任</li>
                </ul>
                <p>
                  <strong>5. 服务声明：</strong>我们保留随时修改、暂停或终止本测试服务的权利，恕不另行通知。测试内容和算法可能会不定期更新优化。
                </p>
                <p class="text-xs text-gray-500 mt-4 pt-4 border-t border-psychology-info-20">
                  继续使用本测试即表示您已阅读、理解并同意以上所有条款。
                </p>
              </div>
            </div>

            <!-- 同意确认 -->
            <div class="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
              <input 
                type="checkbox" 
                id="consent-checkbox"
                v-model="hasConsented"
                class="w-5 h-5 text-psychology-primary border-gray-300 rounded focus:ring-psychology-primary focus:ring-2 cursor-pointer flex-shrink-0"
              />
              <label for="consent-checkbox" class="flex-1 text-sm text-gray-700 cursor-pointer select-none leading-relaxed">
                我已阅读并理解以上免责声明，自愿参加本测试，并同意测试的使用条款
              </label>
            </div>

            <!-- 开始按钮 -->
            <div class="text-center">
              <button 
                @click="startAssessment"
                :disabled="!hasConsented"
                :class="[
                  'px-12 py-4 text-lg font-semibold rounded-lg transition-all inline-flex items-center gap-2',
                  hasConsented
                    ? 'bg-psychology-primary text-white hover:bg-psychology-primary/90 hover:shadow-lg hover:-translate-y-0.5 cursor-pointer' 
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                ]"
              >
                <span>开始测试</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>
              <!-- 提示文字：使用opacity和visibility避免布局跳动 -->
              <div 
                class="hint-message"
                :class="{ 'hint-visible': !hasConsented, 'hint-hidden': hasConsented }"
              >
                <p class="text-sm text-gray-500 mt-3">
                  <span v-if="!hasConsented">请先阅读并同意免责声明</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部说明 -->
        <div class="text-center text-xs text-gray-500">
          <p>本测试基于John Holland教授的RIASEC六维度职业兴趣模型，通过科学算法精准计算你的Holland Code和职业兴趣类型。</p>
        </div>
      </div>
    </main>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script>
import IncompleteSessionDialog from '../components/assessment/IncompleteSessionDialog.vue'
import BackToTop from '../components/BackToTop.vue'
import { 
  getIncompleteSession, 
  getSessionProgressInfo, 
  clearSessionProgress
} from '../utils/sessionStorage.js'

export default {
  name: 'StartAssessmentPage',
  components: {
    IncompleteSessionDialog,
    BackToTop
  },
  data() {
    return {
      hasConsented: false,
      showIncompleteDialog: false,
      incompleteSessionInfo: null
    }
  },
  created() {
    // 检查未完成会话
    this.checkIncompleteSession()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    checkIncompleteSession() {
      // 检查是否有未完成的会话（霍兰德测试）
      const incompleteSession = getIncompleteSession()
      if (incompleteSession) {
        this.incompleteSessionInfo = getSessionProgressInfo(incompleteSession.id)
        this.showIncompleteDialog = true
        console.log('Found incomplete session:', this.incompleteSessionInfo)
      }
    },
    handleContinueSession() {
      // 继续未完成的会话
      const incompleteSession = getIncompleteSession()
      if (incompleteSession) {
        this.$router.push({
          path: '/assessment/questions',
          query: { 
            sessionId: incompleteSession.id
          }
        })
      }
    },
    handleRestartSession() {
      // 重新开始，清除未完成会话
      const incompleteSession = getIncompleteSession()
      if (incompleteSession) {
        // 删除未完成的会话
        const { deleteSession } = require('../utils/sessionStorage.js')
        deleteSession(incompleteSession.id)
      }
      
      // 清除进度数据
      clearSessionProgress()
      
      // 隐藏对话框
      this.showIncompleteDialog = false
    },
    handleCancelDialog() {
      // 点击背景关闭对话框
      this.showIncompleteDialog = false
    },
    startAssessment() {
      // 检查是否有未完成的会话
      const incompleteSession = getIncompleteSession()
      if (incompleteSession) {
        // 如果有未完成会话，显示对话框
        this.incompleteSessionInfo = getSessionProgressInfo(incompleteSession.id)
        this.showIncompleteDialog = true
        return // 不跳转，等待用户选择
      }
      
      // 没有未完成会话，跳转到基本信息页面
      this.$router.push({
        path: '/assessment/info'
      })
    }
  }
}
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.btn-primary:hover {
  transform: translateY(-2px);
}

.btn-primary:active {
  transform: translateY(0);
}

/* 提示文字样式：避免布局跳动 */
.hint-message {
  min-height: 1.5rem; /* 固定最小高度，保持布局稳定 */
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.hint-visible {
  opacity: 1;
  visibility: visible;
}

.hint-hidden {
  opacity: 0;
  visibility: hidden;
  /* 保持元素在布局流中，但不显示 */
  pointer-events: none;
}
</style>
